export function localGet (key:string) {
  return window.localStorage.getItem(key)
}
  
export function localSet (key:string, value:any) {
  window.localStorage.setItem(key, JSON.stringify(value).toString().replaceAll("\"",""))
}

export function localRemove (key:string) {
  window.localStorage.removeItem(key)
}

export function sessionGet (key:string) {
  try {
    return window.sessionStorage.getItem(key) || ''
  } catch {
    return ''
  }
}

export function sessionSet (key:string, value:any) {
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value))
  } catch {
    // 隐私模式下存储可能不可用，页面仍应正常工作。
  }
}

export function sessionRemove (key:string) {
  try {
    window.sessionStorage.removeItem(key)
  } catch {
    // 隐私模式下存储可能不可用，页面仍应正常工作。
  }
}

export function parseJwt (token:string) {
  console.log({token})
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

export function getUid(){
  var token:string = localGet("x-token")||''
  if(!token){
    return ""
  }

  var tokenJson = parseJwt(token)
  console.log({tokenJson})
  return tokenJson.ID
}
